import { Box, Button, ButtonGroup, Card, CardContent, Chip, CircularProgress, colors, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid2, IconButton, InputLabel, MenuItem, OutlinedInput, Pagination, Paper, Select, Snackbar, SnackbarContent, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, TextField, Tooltip, Typography } from "@mui/material"
import { useContext, useEffect, useState } from "react";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import '../jobPostings/jobpostings.css';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { TableLoader } from "../../reusable_components/components/TableLoader";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import { useSelectRecruiterListMutation } from "../../redux/jobpostings/jobpostings.api";
import { Navigate, useNavigate } from "react-router-dom";
import { useCommissionOneTimeListMutation, useCommissionRecurringListMutation, useGetCommissionManagementMutation, useMakeCommissionTrackerDetailsMutation, useUpdateCommissionManagementMutation } from "../../redux/commissionManagement/commissionManagement.api";
import dayjs from "dayjs";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Close, IsoTwoTone, TurnRight } from "@mui/icons-material";
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker";
import { Controller, useForm } from "react-hook-form";
import Dropdown from "../../reusable_components/components/Dropdown";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { CalendarIcon } from "lucide-react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import PercentIcon from "@mui/icons-material/Percent";
import CommissionLoader from "../../reusable_components/components/CommissionLoader";
import securePayment from '../../assets/securePayment.png'
import {ArrowRight } from 'lucide-react'; // or use @mui/icons-material
import MUIButton from "../../reusable_components/components/MUIButton";

const CommissionManagement = () => {

    const { Snackbar } = useContext(SnackbarContext)
    const [showTableLoader, setShowTableLoader] = useState(false)
    const [commissionDatas, setCommissionDatas] = useState([])
    const [recurringCommissionDatas, setRecurringCommissionDatas] = useState([])
    const [openContractDialog, setOpenContractDialog] = useState(false);
    const [isAmount, setIsAmount] = useState(false)
    const [profileName, setProfileName] = useState("")
    const [profileId, setProfileId] = useState()
    const [positionId, setPositionId] = useState()
    const [overAllLoader, setOverAllLoader] = useState(false);

    // API's
    const [getCommissionDataById] = useGetCommissionManagementMutation()
    const [updateCommission] = useUpdateCommissionManagementMutation()
    const [oneTimecommissionList] = useCommissionOneTimeListMutation()
    const [recurringCommissionList] = useCommissionRecurringListMutation()
    const [proccedCommission] = useMakeCommissionTrackerDetailsMutation()

    const contractValidationSchema = Yup.object().shape({
        contractCandidateJoiningDate: Yup.string()
            .required("Candidate joining date is required"),

        billingRate: Yup.number()
            .transform((value, originalValue) =>
                originalValue === "" ? undefined : value
            )
            .when('commissionMode', {
                is: (val) => val !== 'OTS',
                then: (schema) => schema.required("Billing rate is required"),
                otherwise: (schema) => schema.notRequired(),
            }),

        units: Yup.string().when('commissionMode', {
            is: (val) => val !== 'OTS',
            then: (schema) => schema.required("Currency is required"),
            otherwise: (schema) => schema.notRequired(),
        }),

        periodOfTime: Yup.string().when('commissionMode', {
            is: (val) => val !== 'OTS',
            then: (schema) => schema.required("Unit is required"),
            otherwise: (schema) => schema.notRequired(),
        }),

        contractOpenDate: Yup.string().when('commissionMode', {
            is: (val) => val !== 'OTS',
            then: (schema) => schema.required("Contract open date is required"),
            otherwise: (schema) => schema.notRequired(),
        }),

        contractCloseDate: Yup.string().when('commissionMode', {
            is: (val) => val !== 'OTS',
            then: (schema) => schema.required("Contract closing date is required"),
            otherwise: (schema) => schema.notRequired(),
        }),

        companyCommissionType: Yup.string()
            .required("Commission type is required"),

        companyCommissionAmount: isAmount
            ? Yup.string()
                .required("Commission Amount is required")
                .test(
                    "is-less-than-salary",
                    "Commission Amount must be less than Salary",
                    function (value) {
                        const { candidateAnnualSalary } = this.parent;
                        if (!value || !candidateAnnualSalary) return true;
                        const commission = parseFloat(value);
                        const salary = parseFloat(candidateAnnualSalary);
                        return !isNaN(commission) && !isNaN(salary) && commission < salary;
                    }
                )
            : Yup.string().notRequired(),
        companyCommissionPercentage: !isAmount
            ? Yup.number()
                .typeError("Commission (%) must be a number")
                .required("Commission (%) is required")
                .min(1, "Value must be greater than 0")
                .max(100, "Percentage cannot exceed 100")
            : Yup.mixed().nullable(),

        commissionMode: Yup.string()
            .required("Commission mode is required"),
        candidateAnnualSalary: Yup.string()
            .required("Salary is required")
            .test(
                "is-positive",
                "Salary must be a positive number",
                (value) => {
                    if (!value) return false;
                    const number = parseFloat(value);
                    return !isNaN(number) && number > 0;
                }
            ),
    });

    const resolver = yupResolver(contractValidationSchema);

    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        getValues,
        watch,
        setValue,
    } = useForm({
        mode: "onChange",
        resolver,
        shouldUnregister: false,
        defaultValues: {},
    });

    // Pagination
    const [page, setPage] = useState(+localStorage?.getItem("localPage") || 1)
    const [totalDataCount, setTotalDataCount] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [count, setCount] = useState(0)
    const [triggerApi, setTriggerApi] = useState(false)
    const [newTab, setNewTab] = useState(localStorage.getItem("newTab") || "Y");

    const navigate = useNavigate()

    const handleChangePage = (e, newPage) => {
        setPage(newPage)        
        localStorage.setItem('localPage' , newPage)
        setTriggerApi(true)
    }

    const handleTabChange = (event, newValue) => {
        setNewTab(newValue);
        localStorage.setItem("newTab", newValue)
        setPage(1)
    };

    const getCommissionList = async () => {
        try {
            const payload = {
                page: page - 1,
                size: rowsPerPage
            }
            setShowTableLoader(true)
            const response = await oneTimecommissionList(payload).unwrap()
            setShowTableLoader(false)
            setCommissionDatas(response?.response?.response)
            setTotalDataCount(response?.response?.response?.totalElements)

        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }

    const getRecurringCommissionList = async () => {
        try {
            setShowTableLoader(true)
            const response = await recurringCommissionList().unwrap()
            setShowTableLoader(false)
            setRecurringCommissionDatas(response?.response?.response)
            setTotalDataCount(response?.response?.response?.totalElements)

        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }

    useEffect(() => {
        getCommissionList()
        // getRecurringCommissionList()
    }, [])

    useEffect(() => {
        if (newTab === "Y") {
            getCommissionList()
        } else {
            getRecurringCommissionList()
        }
    }, [newTab])

    useEffect(() => {
        if (triggerApi) {
            getCommissionList()
            setTriggerApi(false)
        }
    }, [rowsPerPage, page, triggerApi])

    const handleCloseContract = () => {
        setOpenContractDialog(false);
        setValue("billingRate", "")
        setValue("candidateAnnualSalary", "")
        // setValue("commissionMode", "")
        setValue("companyCommissionAmount", "")
        setValue("companyCommissionPercentage", "")
        setValue("companyCommissionType", "")
        setValue("contractCandidateJoiningDate", null)
        setValue("contractCloseDate", null)
        setValue("contractOpenDate", null)
        setValue("periodOfTime", "")
        setValue("units", "")
    }

    const modeOfCommission = watch("commissionMode")
    const commissionType = watch("companyCommissionType")
    const contractOpenDate = watch("contractOpenDate")

    useEffect(() => {
        if (commissionType !== "FC") {
            setIsAmount(false)
            setValue("companyCommissionAmount", "")
            setCommissionAmt("")
        } else {
            setIsAmount(true)
            setValue("companyCommissionPercentage", "")
        }
    }, [commissionType])

    const units = [
        {
            id: 1,
            label: "INR",
        },
        {
            id: 2,
            label: "USD",
        },
        {
            id: 3,
            label: "CAD",
        },
        {
            id: 4,
            label: "AED",
        },
    ];

    const periodOfTime = [
        {
            id: "Y",
            label: "Per Year",
        },
        {
            id: "M",
            label: "Per Month",
        },
        {
            id: "D",
            label: "Per Day",
        },
        {
            id: "H",
            label: "Per Hour",
        },
    ];

    const rewardTypes = [
        {
            id: "FC",
            label: "Fixed Amount",
        },
        {
            id: "FP",
            label: "Fixed Percentage",
        },
    ];

    const commissionMode = [
        {
            id: 'OTS',
            label: 'One Time Settlement'
        },
        // {
        //     id: 'RCP',
        //     label: 'Recurring'
        // },

    ]
    const [commissionId, setCommissionId] = useState()
    const handleOpenEditCommissionDialog = (item) => {
        setOpenContractDialog(true)
        getCommissionDetailsById(item?.id)
        setProfileName(item?.profileName)
        setProfileId(item?.profileId)
        setPositionId(item?.positionId)
        setCommissionId(item?.id)

    }

    const [commissionAmt, setCommissionAmt] = useState()

    const getCommissionDetailsById = async (id) => {
        setOverAllLoader(true);
        try {
            const payload = {
                cmId: id
            }
            const response = await getCommissionDataById(payload).unwrap()
            setValue("billingRate", response?.data?.candidateSalary)
            setValue("candidateAnnualSalary", response?.data?.candidateSalary)
            setValue("commissionMode", response?.data?.candidateCommissionMode)
            setCommissionAmt(response?.data?.companyCommissionAmount)
            setValue("companyCommissionAmount", response?.data?.companyCommissionAmount)
            setValue("companyCommissionPercentage", response?.data?.companyCommissionPercentage)
            setValue("companyCommissionType", response?.data?.companyCommissionType !== null ? response?.data?.companyCommissionType === "FP" ? "FP" : "FC" : null)
            setValue("contractCandidateJoiningDate", dayjs(response?.data?.candidateJoiningDate));
            setValue("contractOpenDate", response?.data?.contractStartDate ? dayjs(response?.data?.contractStartDate) : null)
            setValue("contractCloseDate", response?.data?.contractEndDate ? dayjs(response?.data?.contractEndDate) : null);
            setValue("periodOfTime", response?.data?.currencyUnit)
            setValue("units", response?.data?.currencyType)

        } catch (error) {
            Snackbar("Error Fetching Commission By Id", 'error')
        } finally {
            setOverAllLoader(false)
        }
    }


    const updateCommissionData = async (data) => {
        try {
            const payload = {
                id: commissionId,
                candidateJoiningDate: data?.contractCandidateJoiningDate ? dayjs(data?.contractCandidateJoiningDate)?.format("YYYY-MM-DD") : null,
                candidateCommissionMode: data?.commissionMode,
                candidateSalary: data?.candidateAnnualSalary,
                currencyType: data?.units,
                currencyUnit: data?.periodOfTime,
                contractStartDate: newTab === "Y" ? null : data?.contractOpenDate ? dayjs(data?.contractOpenDate)?.format("YYYY-MM-DD") : null,
                contractEndDate: newTab === "Y" ? null : data?.contractCloseDate ? dayjs(data?.contractCloseDate)?.format("YYYY-MM-DD") : null,
                companyCommissionType: data?.companyCommissionType,
                companyCommissionPercentage: data?.companyCommissionPercentage,
                companyCommissionAmount: data?.companyCommissionAmount,
                status: data?.status,
                reasonForCancellation: data?.reasonForCancellation,
                profileID: profileId,
                positionId: positionId
            }
            const response = await updateCommission(payload).unwrap()
            getCommissionList()
            getRecurringCommissionList()
            handleCloseContract()
            Snackbar(response?.message, "success");

        } catch (error) {
            Snackbar("Error while Update", 'error')
            console.log(error, 'error');
        }
    }

    const [openFinalCommissionDialog, setFinalCommissionDialog] = useState(false);
    const [values, setValues] = useState({
        candidatePct: "",
        clientPct: "",
        jobPct: "",
    });
    const [isReferral, setIsReferrel] = useState({
        isClient: "",
        isPoisition: "",
        isCandidate: "",
    });

    const [candidateType, setCandidateType] = useState("");
    const [clientType, setClientType] = useState("");
    const [jobType, setJobType] = useState("");
    const [clientReferredBy, setClientReferredBy] = useState("")    
    const [jobReferredBy, setjobReferredBy] = useState("")
    const [candidtaeReferredBy, setcandidtaeReferredBy] = useState("")
    const [companyAmount, setCompanyAmount] = useState(0);
    const [loading, setLoading] = useState(false); // ⬅️ loader state
    const [readyToCalculate, setReadyToCalculate] = useState(false);
    const handleChange = (field) => (e) => {
        setValues((prev) => ({ ...prev, [field]: e.target.value }));
    };

    const calculateAmount = (value, type, ref) => {
        const amount = parseFloat(value);
        if (isNaN(amount) || amount <= 0) return 0;

        if (!ref) {
            return 0
        } else if (type === "FC") {
            return amount;
        }
        else {
            return ((companyAmount * amount) / 100).toFixed(2);
        }
    };

    // Conditional calculations
    const candidateAmt = readyToCalculate
        ? calculateAmount(values.candidatePct, candidateType, isReferral?.isCandidate)
        : 0;
    const clientAmt = readyToCalculate
        ? calculateAmount(values.clientPct, clientType, isReferral?.isClient)
        : 0;
    const jobAmt = readyToCalculate
        ? calculateAmount(values.jobPct, jobType, isReferral?.isPoisition)
        : 0;

    const totalUsed =
        parseFloat(candidateAmt) + parseFloat(clientAmt) + parseFloat(jobAmt);
    const remainingAmt = companyAmount - totalUsed;

    const handleOpenFinalDialog = (item) => {
        setFinalCommissionDialog(true);
        setLoading(true);
        setReadyToCalculate(false);
        setTimeout(() => {
            setCompanyAmount(item?.companyCommission);
            setIsReferrel({
                isClient: item?.isClientRef,
                isPoisition: item?.isJobRef,
                isCandidate: item?.isProfileRef
            })

            setValues({
                clientPct: item?.contractRewardType !== null ? item?.contractRewardType === "FP" ? item?.contractRewardPct : item?.contractRewardAmount :
                    item?.clientRewardType === "FP"
                        ? item?.clientRewPct
                        : item?.clientAmt,
                jobPct:
                    item?.positionRewardType === "FP"
                        ? item?.positionRewPct
                        : item?.positionRewAmt,
                candidatePct:
                    item?.candidateRewardType === "FP"
                        ? item?.canRewPct
                        : item?.canRewAmt,
            });

            setCandidateType(item?.candidateRewardType);
            setClientType(item?.clientRewardType || item?.contractRewardType);
            setJobType(item?.positionRewardType);
            setClientReferredBy(item?.clientReferred)
            setjobReferredBy(item?.jobReferred)
            setcandidtaeReferredBy(item?.candidateReferred)
            setCommissionId(item?.id)
            setTimeout(() => {
                setLoading(false);
                setReadyToCalculate(true);
            }, 1000);
        }, 300);
    };

    const handleCloseFinalCommissionDialog = () => {
        setFinalCommissionDialog(false);
        setValues((prev) =>
            Object.fromEntries(Object.keys(prev).map((key) => [key, ""]))
        );
        setCandidateType("");
        setClientType("");
        setJobType("");
        setReadyToCalculate(false);
    };

    const completeCommission = async () => {
        try {
            const payload = {
                commissionManagementId: commissionId,
                companyCommission: companyAmount,
                candidateRewardType: candidateType,
                candidateRewardPercentage: candidateType === "FP" ? values.candidatePct : null,
                candidateRewardAmount: candidateType === "FC" ? values.candidatePct : null,
                clientRewardType: clientType,
                clientRewardPct: clientType === "FP" ? values.clientPct : null,
                clientRewardAmount: clientType === "FC" ? values.clientPct : null,
                rewardType: jobType,
                rewardPct: jobType === "FP" ? values.jobPct : null,
                rewardAmount: jobType === "FC" ? values.jobPct : null,
                positionCommissionAmount: jobAmt,
                profileCommissionAmount: candidateAmt,
                clientCommissionAmount: clientAmt,
                companyProfit: remainingAmt
            };
            const Proceed = await proccedCommission(payload).unwrap()
            if (Proceed?.status === 200) {
                Snackbar(Proceed?.response?.message, "success")
                setFinalCommissionDialog(false)
                getRecurringCommissionList()
                getCommissionList()
            }

        } catch (error) {
            console.error(error, "error");
            Snackbar("Network Error", 'error')

        }
    }

    const handleNavCommission = (item) => {
        navigate("/referral-payments", {
            state: {
                isOTS: newTab, profileId: item?.profileId, positionId: item?.positionId, candidateName: item?.profileName, clientName: item?.clientName, positionName: item?.positionName, companyCommission: item?.companyCommission , commissionManagementId:item?.id
            }
        })
    }

    const chipStyle = (type) => ({
        backgroundColor: type === "FA" ? "#4db6ac" : "#5C8DF6",
        color: "#fff",
        fontWeight: 600,
        fontSize: "11.5px",
        height: "22px",
        borderRadius: "10px",
        px: 0.8,
        mb: 0.6,
        "& .MuiChip-label": {
            px: 0.8,
        },
        width: 100
    });

    const isInvalid =
        remainingAmt < 0 ||
        (isReferral?.isCandidate && candidateType === "FP" && parseFloat(values.candidatePct) > 100) ||
        (isReferral?.isClient && clientType === "FP" && parseFloat(values.clientPct) > 100) ||
        (isReferral?.isPoisition && jobType === "FP" && parseFloat(values.jobPct) > 100);

    return (
        <Box className='container'>

            <Box sx={{ p: 2 }}>
                {/* ---------- HEADER ---------- */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: "#0C0C0C" }}>
                        Commission Management
                    </Typography>

                    <Box sx={{ display: "flex", gap: 1.5 }}>
                        {/* FA CHIP */}
                        <Chip
                            icon={<CurrencyRupeeIcon sx={{ fontSize: "1rem", color: "white" }} />}
                            label="FA – Fixed Amount"
                            sx={{
                                backgroundColor: "#10B981",
                                color: "white",
                                fontWeight: 600,
                                borderRadius: "12px",
                                px: 1.5,
                                height: 28,
                                fontSize: "0.8rem",
                                "& .MuiChip-icon": { color: "white", ml: 0.5 },
                                "&:hover": { backgroundColor: "#0EA370" },
                            }}
                        />

                        {/* FP CHIP */}
                        <Chip
                            icon={<PercentIcon sx={{ fontSize: "1rem", color: "white" }} />}
                            label="FP – Fixed Percentage"
                            sx={{
                                backgroundColor: "#3B82F6",
                                color: "white",
                                fontWeight: 600,
                                borderRadius: "12px",
                                px: 1.5,
                                height: 28,
                                fontSize: "0.8rem",
                                "& .MuiChip-icon": { color: "white", ml: 0.5 },
                                "&:hover": { backgroundColor: "#2563EB" },
                            }}
                        />
                    </Box>
                </Box>

                {/* ---------- TABS ---------- */}
                <Box
                    sx={{
                        display: "inline-flex",
                        backgroundColor: "#f5f5f6ff",
                        borderRadius: "12px",
                        p: "3px",
                    }}
                >
                    <Tabs
                        value={newTab}
                        onChange={handleTabChange}
                        TabIndicatorProps={{ style: { display: "none" } }}
                    >
                        <Tab
                            label="One Time Settlement"
                            value="Y"
                            sx={{
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: "0.9rem",
                                color: newTab === "Y" ? "#101828" : "#667085",
                                backgroundColor: newTab === "Y" ? "white" : "transparent",
                                borderRadius: "10px",
                                px: 2.5,
                                mx: 0.3,
                                minHeight: 36,
                                boxShadow: newTab === "Y" ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
                            }}
                        />
                        {/* <Tab
                            label="Recurring"
                            value="N"
                            sx={{
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: "0.9rem",
                                color: newTab === "N" ? "#101828" : "#667085",
                                backgroundColor: newTab === "N" ? "white" : "transparent",
                                borderRadius: "10px",
                                px: 2.5,
                                mx: 0.3,
                                minHeight: 36,
                                boxShadow: newTab === "N" ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
                            }}
                        /> */}
                    </Tabs>
                </Box>
            </Box>
            <TabContext value={newTab}>
                <TabPanel value="Y" sx={{ display: "flex", padding: 0.5 }}>
                    <Paper sx={{ width: '100%', overflow: 'auto', border: '1px solid #E9EAEB' }} elevation={0}>
                        <Table>
                            {/* ---------- TABLE HEADER ---------- */}
                            <TableHead
                                style={{
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 10,
                                    width: '100%',
                                }}
                            >
                                {/* 🔹 Top Header Row */}
                                <TableRow
                                    sx={{
                                        '& .MuiTableCell-root': {
                                            borderBottom: 'none',
                                        },
                                    }}
                                >
                                    <TableCell className="tableHeadersCell" rowSpan={2}>
                                        Candidate & Position & Client
                                    </TableCell>

                                    <TableCell
                                        className="tableHeadersCell"
                                        rowSpan={2}
                                    >
                                        Joining Date
                                    </TableCell>
                                    <TableCell
                                        className="tableHeadersCell"
                                        rowSpan={2}
                                        sx={{ borderRight: '1px solid' }}
                                    >
                                        Annual Salary
                                    </TableCell>

                                    {/* Commission heading spanning 4 columns */}
                                    <TableCell
                                        className="tableHeadersCell"
                                        colSpan={4}
                                        align="center"
                                        sx={{
                                            borderLeft: '1px solid',
                                            borderRight: '1px solid',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        Commissions
                                    </TableCell>

                                    <TableCell
                                        className="tableHeadersCell"
                                        rowSpan={2}
                                        align="center"
                                        sx={{ borderLeft: '1px solid' }}
                                    >
                                        Action
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell
                                        className="tableHeadersCell"
                                        sx={{ borderRight: '1px solid' }}
                                        align="center"

                                    >
                                        Company
                                    </TableCell>
                                    <TableCell
                                        className="tableHeadersCell"
                                        sx={{ borderRight: '1px solid' }}
                                        align="center"
                                    >
                                        Client
                                    </TableCell>
                                    <TableCell
                                        className="tableHeadersCell"
                                        sx={{ borderRight: '1px solid' }}
                                        align="center"
                                    >
                                        Job
                                    </TableCell>
                                    <TableCell className="tableHeadersCell" align="center">
                                        Candidate
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            {/* ---------- TABLE BODY ---------- */}
                            {!showTableLoader ? (
                                commissionDatas?.data?.length > 0 ? (
                                    <TableBody>
                                        {commissionDatas?.data?.map((item, index) => (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                    '&:hover': { backgroundColor: '#f1f1f1' },
                                                }}
                                            >
                                                {/* Candidate & Position & Client */}
                                                <TableCell className="tableBodyCell">
                                                    <span style={{ color: '#53389E', fontWeight: 600 }}>
                                                        {item.id} {item?.profileName}
                                                    </span>
                                                    <br />
                                                    {item?.clientName}
                                                    <br />
                                                    <span>{item?.positionName}</span>
                                                </TableCell>

                                                {/* Joining Date / Annual Salary */}
                                                <TableCell className="tableBodyCell">
                                                    <span style={{ fontWeight: 600, cursor: 'pointer' }}>
                                                        {dayjs(item.candidateJoiningDate).format('DD-MM-YYYY')}
                                                    </span>
                                                    {/* <br />
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                        <Typography sx={{ fontSize: '12.5px' }}>
                                                            {item?.candidateSalary || '0.00'}
                                                        </Typography>
                                                    </Box> */}
                                                </TableCell>
                                                {/* Joining Date / Annual Salary */}
                                                <TableCell className="tableBodyCell">
                                                    {/* <span style={{ fontWeight: 600, cursor: 'pointer' }}>
                                                        {dayjs(item.candidateJoiningDate).format('DD-MM-YYYY')}
                                                    </span>
                                                    <br /> */}
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                        <Typography sx={{ fontSize: '12.5px' }}>
                                                            {item?.candidateSalary || '0.00'}
                                                        </Typography>
                                                    </Box>
                                                </TableCell>
                                                <TableCell className="tableBodyCell" align="center">
                                                    {item?.companyCommissionType === "FC" ? (
                                                        <Chip
                                                            label={`FA – ₹${item?.companyCommissionAmount}`}
                                                            sx={{
                                                                backgroundColor: "#10B981",
                                                                color: "white",
                                                                fontWeight: 600,
                                                                fontSize: "0.75rem",
                                                                minWidth: 100,
                                                                height: 24,
                                                                borderRadius: "16px",
                                                                px: 1,
                                                                "& .MuiChip-icon": { color: "white", ml: 0.5 },
                                                            }}
                                                        />
                                                    ) : item?.companyCommissionPercentage != null ? (
                                                        <Box display="flex" flexDirection="column" alignItems="center">
                                                            <Chip label={`FP – ${item?.companyCommissionPercentage}%`} sx={chipStyle("FP")} />
                                                            <Typography sx={{ fontWeight: 700, color: "#2c3e50", fontSize: "13px", mt: 0.5 }}>
                                                                ₹ {item?.companyCommission?.toLocaleString("en-IN")}
                                                            </Typography>
                                                        </Box>
                                                    ) : (
                                                        "NA"
                                                    )}
                                                </TableCell>

                                                {/* ---------- Client Commission ---------- */}
                                                <TableCell className="tableBodyCell" align="center">
                                                    {!item?.isClientRef ? (
                                                        <span style={{ fontFamily: "'Courier New', monospace", fontWeight: 'bold' }}>NA</span>
                                                    ) : item?.clientRewardType === "FC" ? (
                                                        <Chip
                                                            label={`FA – ₹${item?.clientAmt}`}
                                                            sx={{
                                                                backgroundColor: "#10B981",
                                                                color: "white",
                                                                fontWeight: 600,
                                                                fontSize: "0.75rem",
                                                                minWidth: 100,
                                                                height: 24,
                                                                borderRadius: "16px",
                                                                px: 1,
                                                                "& .MuiChip-icon": { color: "white", ml: 0.5 },
                                                            }}
                                                        />
                                                    ) : item?.clientRewPct != null ? (
                                                        <Box display="flex" flexDirection="column" alignItems="center">
                                                            <Chip label={`FP – ${item?.clientRewPct}%`} sx={chipStyle("FP")} />
                                                            <Typography sx={{ fontWeight: 700, color: "#2c3e50", fontSize: "13px", mt: 0.5 }}>
                                                                ₹ {Math.round((item?.companyCommission * item?.clientRewPct) / 100).toLocaleString("en-IN")}
                                                            </Typography>
                                                        </Box>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </TableCell>

                                                {/* ---------- Job Commission ---------- */}
                                                <TableCell className="tableBodyCell" align="center">
                                                    {!item?.isJobRef ? (
                                                        <span style={{ fontFamily: "'Courier New', monospace", fontWeight: 'bold' }}>NA</span>

                                                    ) : item?.positionRewardType === "FC" ? (
                                                        <Chip
                                                            label={`FA – ₹${item?.positionRewAmt}`}
                                                            sx={{
                                                                backgroundColor: "#10B981",
                                                                color: "white",
                                                                fontWeight: 600,
                                                                fontSize: "0.75rem",
                                                                minWidth: 100,
                                                                height: 24,
                                                                borderRadius: "16px",
                                                                px: 1,
                                                                "& .MuiChip-icon": { color: "white", ml: 0.5 },
                                                            }}
                                                        />

                                                    ) : item?.positionRewPct != null ? (
                                                        <Box display="flex" flexDirection="column" alignItems="center">
                                                            <Chip label={`FP – ${item?.positionRewPct}%`} sx={chipStyle("FP")} />
                                                            <Typography sx={{ fontWeight: 700, color: "#2c3e50", fontSize: "13px", mt: 0.5 }}>
                                                                ₹ {Math.round((item?.companyCommission * item?.positionRewPct) / 100).toLocaleString("en-IN")}
                                                            </Typography>
                                                        </Box>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </TableCell>

                                                {/* ---------- Candidate Commission ---------- */}
                                                <TableCell className="tableBodyCell" align="center">
                                                    {!item?.isProfileRef ? (
                                                        <span style={{ fontFamily: "'Courier New', monospace", fontWeight: 'bold' }}>NA</span>

                                                    ) : item?.candidateRewardType === "FC" ? (
                                                        <Chip
                                                            label={`FA – ₹${item?.canRewAmt}`}
                                                            sx={{
                                                                backgroundColor: "#10B981",
                                                                color: "white",
                                                                fontWeight: 600,
                                                                fontSize: "0.75rem",
                                                                minWidth: 100,
                                                                height: 24,
                                                                borderRadius: "16px",
                                                                px: 1,
                                                                "& .MuiChip-icon": { color: "white", ml: 0.5 },
                                                            }}
                                                        />
                                                    ) : item?.canRewPct != null ? (
                                                        <Box display="flex" flexDirection="column" alignItems="center">
                                                            <Chip label={`FP – ${item?.canRewPct}%`} sx={chipStyle("FP")} />
                                                            <Typography sx={{ fontWeight: 700, color: "#2c3e50", fontSize: "13px", mt: 0.5 }}>
                                                                ₹ {Math.round((item?.companyCommission * item?.canRewPct) / 100).toLocaleString("en-IN")}
                                                            </Typography>
                                                        </Box>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </TableCell>

                                                {/* Action Buttons */}
                                                <TableCell
                                                    className="tableBodyCell"
                                                    sx={{ color: '#6941C6', fontWeight: 'bold', cursor: 'pointer' }}
                                                >
                                                    <Box sx={{ display: 'flex', alignItems: "center", justifyContent: "space-around" }}>
                                                        {
                                                            !item?.isCommissionTrackerCreated && (
                                                                <IconButton onClick={() => handleOpenEditCommissionDialog(item)}>
                                                                    <Tooltip title="Edit" placement="top" slotProps={{
                                                                        tooltip: {
                                                                            sx: {
                                                                                backgroundColor: "#0A0D12",
                                                                                borderRadius: "8px",
                                                                                padding: "8px 12px",
                                                                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                                                            },
                                                                        },
                                                                    }}>
                                                                        <EditOutlinedIcon />
                                                                    </Tooltip>
                                                                </IconButton>
                                                            )
                                                        }
                                                        {
                                                            !item?.isClientRef && !item?.isJobRef && !item?.isProfileRef ? (
                                                                <></>
                                                            ) : (
                                                                <Box>
                                                                    {
                                                                        !item?.isCommissionTrackerCreated ? (
                                                                            <Tooltip title="Make Commission" placement="top" slotProps={{
                                                                                tooltip: {
                                                                                    sx: {
                                                                                        backgroundColor: "#0A0D12",
                                                                                        borderRadius: "8px",
                                                                                        padding: "8px 12px",
                                                                                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                                                                    },
                                                                                },
                                                                            }}>
                                                                                <img
                                                                                    onClick={() => handleOpenFinalDialog(item)}
                                                                                    src={securePayment}
                                                                                    alt="calculation"
                                                                                    style={{
                                                                                        height: 20,
                                                                                        width: 20,
                                                                                    }}
                                                                                />
                                                                            </Tooltip>
                                                                        ) : (
                                                                            <Tooltip title="View" placement="top" slotProps={{
                                                                                tooltip: {
                                                                                    sx: {
                                                                                        backgroundColor: "#0A0D12",
                                                                                        borderRadius: "8px",
                                                                                        padding: "8px 12px",
                                                                                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                                                                    },
                                                                                },
                                                                            }}>
                                                                                <VisibilityOutlinedIcon sx={{ fontSize: '20px', color: "#b1a9a9ff" }} onClick={() => handleNavCommission(item)} />
                                                                            </Tooltip>
                                                                        )
                                                                    }
                                                                </Box>
                                                            )
                                                        }
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                ) : (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Typography className="emptydatas">No Data Found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                )
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={13}>
                                        <Box className="tableloader">
                                            <TableLoader />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )}

                            {/* ---------- PAGINATION ---------- */}
                            {Math.ceil(totalDataCount / rowsPerPage) > 1 && (
                                <TableRow>
                                    <TableCell colSpan={100}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <MUICancelButton
                                                title="Previous"
                                                startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                                onClick={() => handleChangePage(null, page - 1)}
                                                disabled={page === 1}
                                                sx={{ height: '36px' }}
                                            />
                                            <Pagination
                                                page={page}
                                                onChange={handleChangePage}
                                                count={Math.ceil(totalDataCount / rowsPerPage)}
                                                siblingCount={1}
                                                boundaryCount={1}
                                                shape="rounded"
                                                hidePrevButton
                                                hideNextButton
                                            />
                                            <MUICancelButton
                                                title="Next"
                                                startIcon={
                                                    <ArrowForwardIcon
                                                        sx={{
                                                            color:
                                                                page === Math.ceil(totalDataCount / rowsPerPage)
                                                                    ? '#a2a2a2'
                                                                    : '#414651',
                                                        }}
                                                    />
                                                }
                                                onClick={() => handleChangePage(null, page + 1)}
                                                disabled={page === Math.ceil(totalDataCount / rowsPerPage)}
                                                sx={{ height: '36px' }}
                                            />
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )}
                        </Table>

                    </Paper>
                </TabPanel>

                <TabPanel value="N" sx={{ display: "flex", padding: 0.5 }}>
                    <Paper sx={{ width: '100%', overflow: 'auto', border: '1px solid #E9EAEB' }} elevation={0}>
                        <Table>
                            <TableHead
                                style={{
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 10,
                                    width: "100%",
                                }}
                            >
                                {/* First Header Row */}
                                <TableRow
                                    sx={{
                                        "& .MuiTableCell-root": {
                                            borderBottom: "none",
                                        },
                                    }}
                                >
                                    <TableCell
                                        className="tableHeadersCell"
                                        rowSpan={2}
                                    >
                                        Candidate & Position & Client
                                    </TableCell>

                                    <TableCell
                                        className="tableHeadersCell"
                                        rowSpan={2}
                                    >
                                        Joining Date
                                    </TableCell>
                                    <TableCell
                                        className="tableHeadersCell"
                                        rowSpan={2}
                                        sx={{ borderRight: '1px solid' }}
                                    >
                                        Billing Rate
                                    </TableCell>

                                    {/* Commission Section */}
                                    <TableCell
                                        className="tableHeadersCell"
                                        align="center"
                                        colSpan={4}
                                        sx={{
                                            borderLeft: "1px solid",
                                            borderRight: "1px solid",
                                            backgroundColor: "#f3f4f6",
                                        }}
                                    >
                                        Commission
                                    </TableCell>

                                    <TableCell
                                        className="tableHeadersCell"
                                        rowSpan={2}
                                        sx={{ borderLeft: "1px solid" }}
                                        align="center"
                                    >
                                        Action
                                    </TableCell>
                                </TableRow>

                                {/* Second Header Row */}
                                <TableRow>
                                    <TableCell
                                        className="tableHeadersCell"
                                        sx={{ borderRight: "1px solid" }}
                                        align="center"
                                    >
                                        Company
                                    </TableCell>
                                    <TableCell
                                        className="tableHeadersCell"
                                        sx={{ borderRight: "1px solid" }}
                                        align="center"
                                    >
                                        Client
                                    </TableCell>
                                    <TableCell
                                        className="tableHeadersCell"
                                        sx={{ borderRight: "1px solid" }}
                                        align="center"
                                    >
                                        Job
                                    </TableCell>
                                    <TableCell className="tableHeadersCell" align="center">
                                        Candidate
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            {!showTableLoader ? (
                                recurringCommissionDatas?.data?.length > 0 ? (
                                    <TableBody>
                                        {recurringCommissionDatas?.data?.map((item, index) => (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    backgroundColor: index % 2 === 1 ? "#FAFAFA" : "inherit",
                                                    "&:hover": { backgroundColor: "#f1f1f1" },
                                                }}
                                            >
                                                {/* Candidate & Position & Client */}
                                                <TableCell className="tableBodyCell">
                                                    <span style={{ color: "#53389E", fontWeight: 600 }}>
                                                        {item.id} {item?.profileName}
                                                    </span>
                                                    <br />
                                                    {item?.clientName}
                                                    <br />
                                                    <span>{item?.positionName}</span>
                                                </TableCell>

                                                {/* Joining Date / Billing Rate */}
                                                <TableCell className="tableBodyCell">
                                                    <span style={{ fontWeight: 600, cursor: "pointer" }}>
                                                        {dayjs(item.candidateJoiningDate).format("DD-MM-YYYY")}
                                                    </span>
                                                    <br />
                                                </TableCell>
                                                <TableCell className="tableBodyCell">
                                                    <Box
                                                        sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
                                                    >
                                                        <CurrencyRupeeIcon sx={{ fontSize: "14px", color: "#a6aba5" }} />
                                                        <Typography sx={{ fontSize: "12.5px" }}>
                                                            {item?.candidateSalary || "0.00"}
                                                        </Typography>
                                                    </Box>
                                                </TableCell>

                                                <TableCell className="tableBodyCell" align="center">
                                                    {item?.companyCommissionType === "FC" ? (
                                                        <Chip
                                                            label={`FA – ₹${item?.companyCommissionAmount}`}
                                                            sx={{
                                                                backgroundColor: "#10B981",
                                                                color: "white",
                                                                fontWeight: 600,
                                                                fontSize: "0.75rem",
                                                                height: 24,
                                                                borderRadius: "16px",
                                                                px: 1,
                                                                "& .MuiChip-icon": { color: "white", ml: 0.5 },
                                                            }}
                                                        />
                                                    ) : item?.companyCommissionPercentage != null ? (
                                                        <Box display="flex" flexDirection="column" alignItems="center">
                                                            <Chip label={`FP – ${item?.companyCommissionPercentage}%`} sx={chipStyle("FP")} />
                                                            <Typography sx={{ fontWeight: 700, color: "#2c3e50", fontSize: "13px", mt: 0.5 }}>
                                                                ₹ {item?.companyCommission?.toLocaleString("en-IN")}
                                                            </Typography>
                                                        </Box>

                                                    ) : (
                                                        "NA"
                                                    )}
                                                </TableCell>

                                                {/* Client Commission */}
                                                <TableCell className="tableBodyCell" align="center">
                                                    {!item?.isClientRef ? (
                                                        <span style={{ fontFamily: "'Courier New', monospace", fontWeight: 'bold' }}>NA</span>

                                                    ) : item?.contractRewardType === "FC" ? (
                                                        <Chip
                                                            icon={<CurrencyRupeeIcon sx={{ fontSize: "0.95rem", color: "white" }} />}
                                                            label={`FA – ₹${item?.contractRewardAmount}`}
                                                            sx={{
                                                                backgroundColor: "#10B981",
                                                                color: "white",
                                                                fontWeight: 600,
                                                                fontSize: "0.75rem",
                                                                height: 24,
                                                                borderRadius: "16px",
                                                                px: 1,
                                                                "& .MuiChip-icon": { color: "white", ml: 0.5 },
                                                            }}
                                                        />
                                                    ) : item?.contractRewardPct != null ? (
                                                        <Box display="flex" flexDirection="column" alignItems="center">
                                                            <Chip label={`FP – ${item?.contractRewardPct}%`} sx={chipStyle("FP")} />
                                                            <Typography sx={{ fontWeight: 700, color: "#2c3e50", fontSize: "13px", mt: 0.5 }}>
                                                                ₹ {Math.round((item?.companyCommission * item?.contractRewardPct) / 100).toLocaleString("en-IN")}
                                                            </Typography>
                                                        </Box>

                                                    ) : (
                                                        "-"
                                                    )}
                                                </TableCell>

                                                {/* Job Commission */}
                                                <TableCell className="tableBodyCell" align="center">
                                                    {!item?.isJobRef ? (
                                                        <span style={{ fontFamily: "'Courier New', monospace", fontWeight: 'bold' }}>NA</span>

                                                    ) : item?.positionRewardType === "FC" ? (
                                                        <Chip
                                                            icon={<CurrencyRupeeIcon sx={{ fontSize: "0.95rem", color: "white" }} />}
                                                            label={`FA – ₹${item?.positionRewAmt}`}
                                                            sx={{
                                                                backgroundColor: "#10B981",
                                                                color: "white",
                                                                fontWeight: 600,
                                                                fontSize: "0.75rem",
                                                                height: 24,
                                                                borderRadius: "16px",
                                                                px: 1,
                                                                "& .MuiChip-icon": { color: "white", ml: 0.5 },
                                                            }}
                                                        />
                                                    ) : item?.positionRewPct != null ? (
                                                        <Box display="flex" flexDirection="column" alignItems="center">
                                                            <Chip label={`FP – ${item?.positionRewPct}%`} sx={chipStyle("FP")} />
                                                            <Typography sx={{ fontWeight: 700, color: "#2c3e50", fontSize: "13px", mt: 0.5 }}>
                                                                ₹ {Math.round((item?.companyCommission * item?.positionRewPct) / 100).toLocaleString("en-IN")}
                                                            </Typography>
                                                        </Box>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </TableCell>

                                                {/* Candidate Commission */}
                                                <TableCell className="tableBodyCell" align="center">
                                                    {!item?.isProfileRef ? (
                                                        <span style={{ fontFamily: "'Courier New', monospace", fontWeight: 'bold' }}>NA</span>
                                                    ) : item?.candidateRewardType === "FC" ? (
                                                        <Chip
                                                            icon={<CurrencyRupeeIcon sx={{ fontSize: "0.95rem", color: "white" }} />}
                                                            label={`FA – ₹${item?.canRewAmt}`}
                                                            sx={{
                                                                backgroundColor: "#10B981",
                                                                color: "white",
                                                                fontWeight: 600,
                                                                fontSize: "0.75rem",
                                                                height: 24,
                                                                borderRadius: "16px",
                                                                px: 1,
                                                                "& .MuiChip-icon": { color: "white", ml: 0.5 },
                                                            }}
                                                        />
                                                    ) : item?.canRewPct != null ? (
                                                        <Box display="flex" flexDirection="column" alignItems="center">
                                                            <Chip label={`FP – ${item?.canRewPct}%`} sx={chipStyle("FP")} />
                                                            <Typography sx={{ fontWeight: 700, color: "#2c3e50", fontSize: "13px", mt: 0.5 }}>
                                                                ₹ {Math.round((item?.companyCommission * item?.canRewPct) / 100).toLocaleString("en-IN")}
                                                            </Typography>
                                                        </Box>

                                                    ) : (
                                                        "-"
                                                    )}
                                                </TableCell>

                                                {/* Action */}
                                                <TableCell
                                                    className="tableBodyCell"
                                                    sx={{
                                                        color: "#6941C6",
                                                        fontWeight: "bold",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <Box sx={{ display: 'flex', alignItems: "center", justifyContent: "space-around" }}>

                                                        {
                                                            !item?.isCommissionTrackerCreated && (
                                                                <IconButton>
                                                                    <Tooltip
                                                                        slotProps={{
                                                                            tooltip: {
                                                                                sx: {
                                                                                    backgroundColor: "#0A0D12",
                                                                                    borderRadius: "8px",
                                                                                    padding: "8px 12px",
                                                                                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                                                                },
                                                                            },
                                                                        }}
                                                                        onClick={() => handleOpenEditCommissionDialog(item)}
                                                                        placement="top"
                                                                        title="Edit"
                                                                        sx={{ color: "#A4A7AE" }}
                                                                    >
                                                                        <EditOutlinedIcon />
                                                                    </Tooltip>
                                                                </IconButton>
                                                            )
                                                        }

                                                        {
                                                            !item?.isClientRef && !item?.isJobRef && !item?.isProfileRef ? (
                                                                <></>
                                                            ) : (
                                                                <Box>
                                                                    {
                                                                        !item?.isCommissionTrackerCreated ? (
                                                                            <Tooltip title="Make Commission" placement="top"
                                                                                slotProps={{
                                                                                    tooltip: {
                                                                                        sx: {
                                                                                            backgroundColor: "#0A0D12",
                                                                                            borderRadius: "8px",
                                                                                            padding: "8px 12px",
                                                                                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                                                                        },
                                                                                    },
                                                                                }}>
                                                                                <img
                                                                                    onClick={() => handleOpenFinalDialog(item)}
                                                                                    src={securePayment}
                                                                                    alt="calculation"
                                                                                    style={{
                                                                                        height: 20,
                                                                                        width: 20,
                                                                                    }}
                                                                                />
                                                                            </Tooltip>
                                                                        ) : (
                                                                            <Tooltip title="View" placement="top"
                                                                                slotProps={{
                                                                                    tooltip: {
                                                                                        sx: {
                                                                                            backgroundColor: "#0A0D12",
                                                                                            borderRadius: "8px",
                                                                                            padding: "8px 12px",
                                                                                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                                                                        },
                                                                                    },
                                                                                }}>
                                                                                <VisibilityOutlinedIcon sx={{ fontSize: '20px', color: "#b1a9a9ff" }} onClick={() => handleNavCommission(item)} />
                                                                            </Tooltip>
                                                                        )
                                                                    }
                                                                </Box>
                                                            )
                                                        }
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                ) : (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Typography className="emptydatas">No Data Found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                )
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={13}>
                                        <Box className="tableloader">
                                            <TableLoader />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )}

                            {/* Pagination Section (unchanged) */}
                            {Math.ceil(totalDataCount / rowsPerPage) > 1 && (
                                <TableRow>
                                    <TableCell colSpan={100}>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                        >
                                            <MUICancelButton
                                                title="Previous"
                                                startIcon={
                                                    <ArrowBackIcon sx={{ color: page === 1 ? "#a2a2a2" : "#414651" }} />
                                                }
                                                onClick={() => handleChangePage(null, page - 1)}
                                                disabled={page === 1}
                                                sx={{ height: "36px" }}
                                            />

                                            <Pagination
                                                page={page}
                                                onChange={handleChangePage}
                                                count={Math.ceil(totalDataCount / rowsPerPage)}
                                                siblingCount={1}
                                                boundaryCount={1}
                                                shape="rounded"
                                                hidePrevButton
                                                hideNextButton
                                            />

                                            <MUICancelButton
                                                title="Next"
                                                startIcon={
                                                    <ArrowForwardIcon
                                                        sx={{
                                                            color:
                                                                page === Math.ceil(totalDataCount / rowsPerPage)
                                                                    ? "#a2a2a2"
                                                                    : "#414651",
                                                        }}
                                                    />
                                                }
                                                onClick={() => handleChangePage(null, page + 1)}
                                                disabled={page === Math.ceil(totalDataCount / rowsPerPage)}
                                                sx={{ height: "36px" }}
                                            />
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )}
                        </Table>

                    </Paper>
                </TabPanel>
            </TabContext>

            <Dialog open={openContractDialog} onClose={handleCloseContract} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, pb: 1 }}>
                    <Typography variant="h6" fontWeight="bold" color="#059669">
                        Edit Commission
                    </Typography>
                    <IconButton onClick={handleCloseContract} sx={{ marginLeft: "auto" }}>
                        <Close />
                    </IconButton>
                </DialogTitle>

                {overAllLoader ? (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            padding: localStorage.getItem("newTab") === "Y" ? 14 : 24
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <DialogContent sx={{ px: 3, pb: 4 }}>
                        <Box>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                                <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
                                    <Box>
                                        <InputLabel>Candidate Name <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <TextField
                                            size="small"
                                            fullWidth
                                            variant="outlined"
                                            value={profileName}
                                            disabled={profileName}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '10px',
                                                    height: '35px'
                                                },
                                            }}
                                        />

                                    </Box>

                                    <Box>
                                        <InputLabel>Candidate Joining Date <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <Controller
                                            control={control}
                                            name="contractCandidateJoiningDate"
                                            render={({ field }) => (
                                                <MuiDatePicker
                                                    {...field}
                                                    slots={{ openPickerIcon: CalendarIcon }}
                                                    slotProps={{
                                                        textField: {
                                                            size: "small",
                                                            placeholder: "Candidate Joining Date",
                                                            InputProps: { sx: { borderRadius: 1 } },
                                                            fullWidth: true,
                                                        },
                                                    }}
                                                    format="DD-MM-YYYY"
                                                    minDate={dayjs()}
                                                />
                                            )}
                                        />
                                        {errors?.contractCandidateJoiningDate?.message && (
                                            <Typography color="error" variant="caption">
                                                {errors?.contractCandidateJoiningDate?.message}
                                            </Typography>
                                        )}
                                    </Box>

                                    <Box>
                                        <InputLabel>Commission Mode <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <Controller
                                            control={control}
                                            name="commissionMode"
                                            render={({ field }) => (
                                                <Dropdown
                                                    {...field}
                                                    displayEmpty
                                                    placeholder="Select Commission Type"
                                                    valueKey="id"
                                                    labelKey="label"
                                                    options={commissionMode || []}
                                                    disabled={modeOfCommission}
                                                    fullWidth
                                                />
                                            )}
                                        />
                                        {errors?.commissionMode?.message && (
                                            <Typography color="error" variant="caption">
                                                {errors?.commissionMode?.message}
                                            </Typography>
                                        )}
                                    </Box>

                                    <Grid2>
                                        <InputLabel className="input">
                                            {modeOfCommission === "OTS" ? "Candidate Annual Salary" : "Candidate Monthly Salary"}<span style={{ color: 'red' }}>*</span>
                                        </InputLabel>
                                        <Controller
                                            control={control}
                                            name="candidateAnnualSalary"
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    type="number"
                                                    className="textfields"
                                                    size="small"
                                                    placeholder={modeOfCommission === "OTS" ? "Annual Salary" : "Monthly Salary"}
                                                    sx={{
                                                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                                                        {
                                                            display: "none",
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                        {errors?.candidateAnnualSalary?.message && (
                                            <div style={{ color: "red", fontSize: "0.7rem" }}>
                                                {errors?.candidateAnnualSalary?.message}
                                            </div>
                                        )}
                                    </Grid2>
                                </Box>

                                {
                                    modeOfCommission !== "OTS" && (
                                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 2 }}>
                                            <Box>
                                                <InputLabel>Billing Rate <span style={{ color: 'red' }}>*</span></InputLabel>
                                                <Controller
                                                    control={control}
                                                    name="billingRate"
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            type="number"
                                                            size="small"
                                                            placeholder="Enter Billing Rate"
                                                            fullWidth
                                                            sx={{
                                                                '& .MuiOutlinedInput-root': {
                                                                    borderRadius: '10px',
                                                                    height: '35px',
                                                                    fontSize: '14px',
                                                                },
                                                                "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                                                                {
                                                                    display: "none",
                                                                },
                                                            }}
                                                            onWheel={(e) => e.target.blur()}
                                                        />
                                                    )}
                                                />
                                                {errors?.billingRate?.message && (
                                                    <Typography color="error" variant="caption">
                                                        {errors?.billingRate?.message}
                                                    </Typography>
                                                )}
                                            </Box>

                                            <Box>
                                                <InputLabel>Currency <span style={{ color: 'red' }}>*</span></InputLabel>
                                                <Controller
                                                    control={control}
                                                    name="units"
                                                    render={({ field }) => (
                                                        <Select
                                                            {...field}
                                                            size="small"
                                                            fullWidth
                                                            displayEmpty
                                                            onChange={(e) => field.onChange(e.target.value)}
                                                            value={field.value || ""}
                                                            input={<OutlinedInput />}
                                                            sx={{
                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                    borderRadius: '10px',
                                                                },
                                                                '& .MuiOutlinedInput-root': {
                                                                    borderRadius: '10px',
                                                                    height: '35px',
                                                                },
                                                                '& .MuiSelect-select': {
                                                                    fontSize: '14px',
                                                                    color: field.value ? '#000' : '#757575',
                                                                },
                                                            }}
                                                        >
                                                            <MenuItem value="" disabled>
                                                                Select Currency
                                                            </MenuItem>
                                                            {units.map((option) => (
                                                                <MenuItem key={option.id} value={option.label}>
                                                                    {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>

                                                    )}
                                                />
                                                {errors?.units?.message && (
                                                    <Typography color="error" variant="caption">
                                                        {errors.units.message}
                                                    </Typography>
                                                )}
                                            </Box>

                                            <Box>
                                                <InputLabel>Unit <span style={{ color: 'red' }}>*</span></InputLabel>
                                                <Controller
                                                    control={control}
                                                    name="periodOfTime"
                                                    render={({ field }) => (
                                                        <Select
                                                            {...field}
                                                            size="small"
                                                            fullWidth
                                                            displayEmpty
                                                            onChange={(e) => field.onChange(e.target.value)}
                                                            value={field.value || ""}
                                                            input={<OutlinedInput />}
                                                            sx={{
                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                    borderRadius: '10px',
                                                                },
                                                                '& .MuiOutlinedInput-root': {
                                                                    borderRadius: '10px',
                                                                    height: '35px',
                                                                },
                                                                '& .MuiSelect-select': {
                                                                    fontSize: '14px',
                                                                    color: field.value ? '#000' : '#757575',
                                                                },
                                                            }}
                                                        >
                                                            <MenuItem value="" disabled>
                                                                Select Unit
                                                            </MenuItem>
                                                            {periodOfTime.map((option) => (
                                                                <MenuItem key={option.id} value={option.id}>
                                                                    {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    )}
                                                />
                                                {errors?.periodOfTime?.message && (
                                                    <Typography color="error" variant="caption">
                                                        {errors.periodOfTime.message}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    )
                                }


                                {/* Commission Section */}
                                <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
                                    <Box>
                                        <InputLabel>Company Commission Type <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <Controller
                                            control={control}
                                            name="companyCommissionType"
                                            render={({ field }) => (
                                                <Dropdown
                                                    {...field}
                                                    displayEmpty
                                                    placeholder="Select Commission Type"
                                                    valueKey="id"
                                                    labelKey="label"
                                                    options={rewardTypes || []}
                                                    disabled={commissionType}
                                                    fullWidth
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '10px',
                                                            height: '35px'
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                        {errors?.companyCommissionType?.message && (
                                            <Typography color="error" variant="caption">
                                                {errors?.companyCommissionType?.message}
                                            </Typography>
                                        )}
                                    </Box>

                                    {isAmount ? (
                                        <Box>
                                            <InputLabel>Commission Amount <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <Controller
                                                control={control}
                                                name="companyCommissionAmount"
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        value={commissionAmt}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setCommissionAmt(value);      // update your local state
                                                            field.onChange(value);        // update RHF form state
                                                        }}
                                                        size="small"
                                                        fullWidth
                                                        placeholder="Enter Commission(Rs)"
                                                        onWheel={(e) => e.target.blur()}
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                borderRadius: '10px',
                                                                height: '35px',
                                                                fontSize: '14px',

                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors?.companyCommissionAmount?.message && (
                                                <Typography color="error" variant="caption">
                                                    {errors?.companyCommissionAmount?.message}
                                                </Typography>
                                            )}
                                        </Box>
                                    ) : (
                                        <Box>
                                            <InputLabel>Commission Percentage <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <Controller
                                                control={control}
                                                name="companyCommissionPercentage"
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        placeholder="Enter Commission(%)"
                                                        onWheel={(e) => e.target.blur()}
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                borderRadius: '10px',
                                                                height: '35px',
                                                                fontSize: '14px',
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors?.companyCommissionPercentage?.message && (
                                                <Typography color="error" variant="caption">
                                                    {errors?.companyCommissionPercentage?.message}
                                                </Typography>
                                            )}
                                        </Box>
                                    )}
                                </Box>

                                {/* Contract Dates */}
                                {
                                    modeOfCommission !== "OTS" && (
                                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
                                            <Box>
                                                <InputLabel>Contract Open Date <span style={{ color: 'red' }}>*</span></InputLabel>
                                                <Controller
                                                    control={control}
                                                    name="contractOpenDate"
                                                    render={({ field }) => (
                                                        <MuiDatePicker
                                                            {...field}
                                                            slots={{ openPickerIcon: CalendarIcon }}
                                                            slotProps={{
                                                                textField: { size: "small", placeholder: "Contract Open Date", fullWidth: true },
                                                            }}
                                                            format="DD-MM-YYYY"
                                                            minDate={dayjs()}
                                                        />
                                                    )}
                                                />
                                                {errors?.contractOpenDate?.message && (
                                                    <Typography color="error" variant="caption">
                                                        {errors?.contractOpenDate?.message}
                                                    </Typography>
                                                )}
                                            </Box>

                                            <Box>
                                                <InputLabel>Contract Close Date <span style={{ color: 'red' }}>*</span></InputLabel>
                                                <Controller
                                                    control={control}
                                                    name="contractCloseDate"
                                                    render={({ field }) => (
                                                        <MuiDatePicker
                                                            {...field}
                                                            slots={{ openPickerIcon: CalendarIcon }}
                                                            slotProps={{
                                                                textField: { size: "small", placeholder: "Contract Close Date", fullWidth: true },
                                                            }}
                                                            format="DD-MM-YYYY"
                                                            minDate={dayjs(contractOpenDate)}
                                                        />
                                                    )}
                                                />
                                                {errors?.contractCloseDate?.message && (
                                                    <Typography color="error" variant="caption">
                                                        {errors?.contractCloseDate?.message}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    )
                                }

                            </Box>
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: 'flex-end', mt: 4 }}>
                            <Button
                                variant="contained"
                                sx={{ bgcolor: "#059669", "&:hover": { bgcolor: "#047857" } }}
                                onClick={handleSubmit(updateCommissionData)}
                            >
                                Edit
                            </Button>
                        </Box>
                    </DialogContent>
                )}
            </Dialog>

            <Dialog
                open={openFinalCommissionDialog}
                onClose={handleCloseFinalCommissionDialog}
                maxWidth={false}
                PaperProps={{
                    sx: {
                        borderRadius: "12px",
                        background: isInvalid ? "#faf1f1ff" : "#ffffff",   // Mild red background
                        minWidth: "60%",
                        maxWidth: "90vw",
                    },
                }}
            >
                <DialogContent sx={{ p: 0 }}>
                    {
                        loading ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minHeight: '400px', // Ensure minimum height for proper centering
                                    width: '100%',
                                }}
                            >
                                {/* Simple Spinner Loader */}
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: 2,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            width: 50,
                                            height: 50,
                                            animation: 'rotate 1.5s linear infinite',
                                            '@keyframes rotate': {
                                                '0%': {
                                                    transform: 'rotate(0deg)',
                                                },
                                                '100%': {
                                                    transform: 'rotate(360deg)',
                                                },
                                            },
                                        }}
                                    >
                                        {[...Array(5)].map((_, index) => (
                                            <Box
                                                key={index}
                                                sx={{
                                                    position: 'absolute',
                                                    width: 6,
                                                    height: 6,
                                                    backgroundColor: '#1a1f71',
                                                    borderRadius: '50%',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: `
                                        translate(-50%, -50%) 
                                        rotate(${index * (360 / 5)}deg) 
                                        translate(20px) 
                                        rotate(-${index * (360 / 5)}deg)
                                    `,
                                                }}
                                            />
                                        ))}
                                    </Box>
                                    <Typography
                                        sx={{
                                            fontSize: '14px',
                                            color: 'text.secondary',
                                            fontWeight: 500,
                                        }}
                                    >
                                        Calculating commissions...
                                    </Typography>
                                </Box>
                            </Box>
                        ) : (
                            // Your existing commission calculator content
                            <>
                                <Box sx={{ p: 2, textAlign: "center" }}>
                                    <Typography
                                        sx={{
                                            fontSize: "20px",
                                            fontWeight: 700,
                                            color: "text.primary",
                                        }}
                                    >
                                        Commission Calculator
                                    </Typography>
                                </Box>

                                {/* Total Amount */}
                                <Box sx={{ px: 2, mb: 2, textAlign: "center" }}>
                                    <Typography
                                        sx={{
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            color: "text.secondary",
                                        }}
                                    >
                                        Total Amount:{" "}
                                        <Typography component="span" sx={{ color: "primary.main", fontWeight: 700 }}>
                                            ₹{companyAmount.toLocaleString('en-IN')}
                                        </Typography>
                                    </Typography>
                                </Box>

                                {/* Commission Sections */}
                                <Box sx={{ px: 2, mb: 2 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 1, justifyContent: 'center' }}>
                                        {/* Candidate Commission */}
                                        {isReferral?.isCandidate && (
                                            <Box sx={{ width: { xs: '100%', sm: '48%', md: '30%' }, minWidth: '280px' }}>
                                                <Typography sx={{ fontSize: '14px', fontWeight: 600, color: 'text.primary', mb: 1 }}>
                                                    Candidate Commission
                                                </Typography>
                                                <Card
                                                    sx={{
                                                        borderLeft: "3px solid #3b82f6",
                                                        borderRadius: "6px",
                                                    }}
                                                >
                                                    <CardContent sx={{ py: 2, px: 2 }}>
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                            <Box>
                                                                <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: 0.5 }}>
                                                                    {candidateType === "FP" ? "Percentage %" : "Amount ₹"}
                                                                </Typography>
                                                                <TextField
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    size="small"
                                                                    value={values.candidatePct}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (candidateType === "FP" && parseFloat(value) > 100) {
                                                                            return;
                                                                        }
                                                                        handleChange("candidatePct")(e);
                                                                    }}
                                                                    inputProps={{
                                                                        type: "number",
                                                                        min: 0,
                                                                        max: candidateType === "FP" ? 100 : undefined,
                                                                        step: candidateType === "FP" ? "0.1" : "1",
                                                                    }}
                                                                    error={candidateType === "FP" && parseFloat(values.candidatePct) > 100}
                                                                    sx={{
                                                                        "& .MuiOutlinedInput-root": {
                                                                            height: 36,
                                                                            borderRadius: "4px",
                                                                            fontSize: "14px",
                                                                        },
                                                                    }}
                                                                />
                                                            </Box>
                                                            <Box
                                                                sx={{
                                                                    backgroundColor: "grey.100",
                                                                    borderRadius: "4px",
                                                                    p: 1.5,
                                                                }}
                                                            >
                                                                <Typography sx={{ fontSize: '11px', color: 'text.secondary', mb: 0.5 }}>
                                                                    To: {candidtaeReferredBy}
                                                                </Typography>
                                                                <Typography sx={{ fontSize: '16px', fontWeight: 700, color: 'text.primary' }}>
                                                                    ₹{candidateAmt.toLocaleString('en-IN')}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                        {candidateType === "FP" && parseFloat(values.candidatePct) > 100 && (
                                                            <Typography sx={{ fontSize: '11px', color: 'error.main', mt: 0.5 }}>
                                                                Max 100%
                                                            </Typography>
                                                        )}
                                                    </CardContent>
                                                </Card>
                                            </Box>
                                        )}

                                        {/* Client Commission */}
                                        {isReferral?.isClient && (
                                            <Box sx={{ width: { xs: '100%', sm: '48%', md: '30%' }, minWidth: '280px' }}>
                                                <Typography sx={{ fontSize: '14px', fontWeight: 600, color: 'text.primary', mb: 1 }}>
                                                    Client Commission
                                                </Typography>
                                                <Card
                                                    sx={{
                                                        borderLeft: "3px solid #10b981",
                                                        borderRadius: "6px",
                                                    }}
                                                >
                                                    <CardContent sx={{ py: 2, px: 2 }}>
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                            <Box>
                                                                <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: 0.5 }}>
                                                                    {clientType === "FP" ? "Percentage %" : "Amount ₹"}
                                                                </Typography>
                                                                <TextField
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    size="small"
                                                                    value={values.clientPct}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (clientType === "FP" && parseFloat(value) > 100) {
                                                                            return;
                                                                        }
                                                                        handleChange("clientPct")(e);
                                                                    }}
                                                                    inputProps={{
                                                                        type: "number",
                                                                        min: 0,
                                                                        max: clientType === "FP" ? 100 : undefined,
                                                                        step: clientType === "FP" ? "0.1" : "1",
                                                                    }}
                                                                    error={clientType === "FP" && parseFloat(values.clientPct) > 100}
                                                                    sx={{
                                                                        "& .MuiOutlinedInput-root": {
                                                                            height: 36,
                                                                            borderRadius: "4px",
                                                                            fontSize: "14px",
                                                                        },
                                                                    }}
                                                                />
                                                            </Box>
                                                            <Box
                                                                sx={{
                                                                    backgroundColor: "grey.100",
                                                                    borderRadius: "4px",
                                                                    p: 1.5,
                                                                }}
                                                            >
                                                                <Typography sx={{ fontSize: '11px', color: 'text.secondary', mb: 0.5 }}>
                                                                    To: {clientReferredBy}
                                                                </Typography>
                                                                <Typography sx={{ fontSize: '16px', fontWeight: 700, color: 'text.primary' }}>
                                                                    ₹{clientAmt.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                        {clientType === "FP" && parseFloat(values.clientPct) > 100 && (
                                                            <Typography sx={{ fontSize: '11px', color: 'error.main', mt: 0.5 }}>
                                                                Max 100%
                                                            </Typography>
                                                        )}
                                                    </CardContent>
                                                </Card>
                                            </Box>
                                        )}

                                        {/* Job Commission */}
                                        {isReferral?.isPoisition && (
                                            <Box sx={{ width: { xs: '100%', sm: '48%', md: '30%' }, minWidth: '280px' }}>
                                                <Typography sx={{ fontSize: '14px', fontWeight: 600, color: 'text.primary', mb: 1 }}>
                                                    Job Commission
                                                </Typography>
                                                <Card
                                                    sx={{
                                                        borderLeft: "3px solid #8b5cf6",
                                                        borderRadius: "6px",
                                                    }}
                                                >
                                                    <CardContent sx={{ py: 2, px: 2 }}>
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                            <Box>
                                                                <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'text.secondary', mb: 0.5 }}>
                                                                    {jobType === "FP" ? "Percentage %" : "Amount ₹"}
                                                                </Typography>
                                                                <TextField
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    size="small"
                                                                    value={values.jobPct}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (jobType === "FP" && parseFloat(value) > 100) {
                                                                            return;
                                                                        }
                                                                        handleChange("jobPct")(e);
                                                                    }}
                                                                    inputProps={{
                                                                        type: "number",
                                                                        min: 0,
                                                                        max: jobType === "FP" ? 100 : undefined,
                                                                        step: jobType === "FP" ? "0.1" : "1",
                                                                    }}
                                                                    error={jobType === "FP" && parseFloat(values.jobPct) > 100}
                                                                    sx={{
                                                                        "& .MuiOutlinedInput-root": {
                                                                            height: 36,
                                                                            borderRadius: "4px",
                                                                            fontSize: "14px",
                                                                        },
                                                                    }}
                                                                />
                                                            </Box>
                                                            <Box
                                                                sx={{
                                                                    backgroundColor: "grey.100",
                                                                    borderRadius: "4px",
                                                                    p: 1.5,
                                                                }}
                                                            >
                                                                <Typography sx={{ fontSize: '11px', color: 'text.secondary', mb: 0.5 }}>
                                                                    To:{jobReferredBy}
                                                                </Typography>
                                                                <Typography sx={{ fontSize: '16px', fontWeight: 700, color: 'text.primary' }}>
                                                                    ₹{jobAmt.toLocaleString('en-IN')}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                        {jobType === "FP" && parseFloat(values.jobPct) > 100 && (
                                                            <Typography sx={{ fontSize: '11px', color: 'error.main', mt: 0.5 }}>
                                                                Max 100%
                                                            </Typography>
                                                        )}
                                                    </CardContent>
                                                </Card>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>

                                {/* Remaining Amount */}
                                <Box sx={{ px: 2, mb: 2, textAlign: "center" }}>
                                    <Typography
                                        sx={{
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            color: "text.secondary",
                                        }}
                                    >
                                        Remaining Amount:{" "}
                                        <Typography
                                            component="span"
                                            sx={{
                                                color: remainingAmt < 0 ? "error.main" : "success.main",
                                                fontWeight: 700
                                            }}
                                        >
                                            ₹{remainingAmt.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                        </Typography>
                                    </Typography>
                                    {remainingAmt < 0 && (
                                        <Typography sx={{ fontSize: "12px", color: "error.main", mt: 0.5 }}>
                                            Commission exceeds total amount
                                        </Typography>
                                    )}
                                </Box>

                                {/* Actions */}
                                <Box sx={{ px: 2, pb: 2 }}>
                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 1 }}>
                                        <MUICancelButton
                                            title="Cancel"
                                            variant="outlined"
                                            size="small"
                                            onClick={handleCloseFinalCommissionDialog}
                                        />
                                        <MUIButton
                                            title={"Proceed"}
                                            variant="contained"
                                            size="small"
                                            disabled={remainingAmt < 0 ||
                                                (isReferral?.isCandidate && candidateType === "FP" && parseFloat(values.candidatePct) > 100) ||
                                                (isReferral?.isClient && clientType === "FP" && parseFloat(values.clientPct) > 100) ||
                                                (isReferral?.isPoisition && jobType === "FP" && parseFloat(values.jobPct) > 100)
                                            }
                                            onClick={completeCommission}
                                            endIcon={<ArrowRight style={{ width: 14, height: 14 }} />}
                                        />
                                    </Box>
                                </Box>
                            </>
                        )
                    }
                </DialogContent>
            </Dialog>
        </Box >
    )
}
export default CommissionManagement;